// Mock data for OnlineCricketID.guru - Cricket ID Provider

export const SITE = {
  brand: "OnlineCricketID",
  domain: "onlinecricketid.guru",
  tagline: "India ki No.1 Cricket ID & Sports Exchange Platform",
  since: 2015,
  users: "50,000+",
  games: "650+",
  whatsappUrl: "https://wa.link/daddyhere",
  telegramUrl: "https://t.me/officialdaddyanna",
  signalUrl: "https://signal.me/#p/+918750268130",
  email: "support@onlinecricketid.guru",
  phone: "+91 87502 68130",
  facebookUrl: "https://www.facebook.com/",
  instagramUrl: "https://www.instagram.com/",
  twitterUrl: "https://x.com/",
  linkedinUrl: "https://www.linkedin.com/",
};

export const NAV_LINKS = [
  { key: "nav.home", label: "Home", path: "/" },
  { key: "nav.cricketId", label: "Cricket ID", path: "/cricket-id" },
  { key: "nav.casino", label: "Casino", path: "/casino" },
  { key: "nav.howToPlay", label: "How to Play", path: "/how-to-play" },
  { key: "nav.aboutUs", label: "About Us", path: "/about-us" },
  { key: "nav.blog", label: "Blog", path: "/blog" },
  { key: "nav.contact", label: "Contact", path: "/contact-us" },
];

export const FEATURES = [
  {
    icon: "Zap",
    title: "Instant ID Activation",
    desc: "Sirf 2 minute me WhatsApp par message karo aur Cricket ID le lo. Koi document upload nahi, koi lamba form nahi.",
  },
  {
    icon: "ShieldCheck",
    title: "100% Safe & Secure",
    desc: "SSL encrypted platform, verified payments, aur user data ki full privacy. Aapka paisa aur info dono surakshit.",
  },
  {
    icon: "Wallet",
    title: "Fastest Withdrawal",
    desc: "Average 3-5 minute me withdrawal. UPI, Bank Transfer, USDT - sab ke through instant payout 24/7.",
  },
  {
    icon: "Trophy",
    title: "650+ Live Games",
    desc: "Cricket ke alawa Teen Patti, Roulette, Aviator, Andar Bahar, Baccarat - sab Evolution & Ezugi providers se.",
  },
  {
    icon: "Headphones",
    title: "24/7 Customer Support",
    desc: "WhatsApp ya Telegram par message karo, average reply time 60 second se kam. Hamesha online.",
  },
  {
    icon: "BadgePercent",
    title: "5% Welcome Bonus",
    desc: "Pehle deposit par 5% welcome bonus aur 10% loss commission - sirf OnlineCricketID users ke liye.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "WhatsApp Par Message",
    desc: "Hamare official WhatsApp link par 'Get Cricket ID' likh kar bhejo.",
  },
  {
    n: "02",
    title: "Username Choose Karo",
    desc: "Apna naam aur preferred username share karo team ke saath.",
  },
  {
    n: "03",
    title: "ID & Password Receive",
    desc: "Sirf 2 minute me activated Cricket ID aur password mil jayega.",
  },
  {
    n: "04",
    title: "Deposit & Play",
    desc: "UPI se balance add karo (min ₹100) aur live betting start karo.",
  },
];

export const EXCHANGES = [
  { name: "TAJ777.COM", user: "Tdemo4", pass: "Vishnu@123", bonus: "5% Welcome Bonus", commission: "10% Loss Commission" },
  { name: "ALLPANELEXCH.COM", user: "Pdemo99", pass: "Vishnu@1234", bonus: "5% Welcome Bonus", commission: "10% Loss Commission" },
  { name: "LORDSEXCH.COM", user: "Ldemo45", pass: "Ab123456", bonus: "5% Welcome Bonus", commission: "10% Loss Commission" },
  { name: "TIGER365.ME", user: "annademo", pass: "Anna@1123", bonus: "5% Welcome Bonus", commission: "10% Loss Commission" },
];

export const FAQS = [
  {
    q: "Kya OnlineCricketID par Cricket ID lena safe hai?",
    a: "Bilkul. 50,000+ users daily hum par trust karte hain. Sabhi transactions SSL encrypted hain aur OnlineCricketID 2015 se same team ke saath operate kar raha hai.",
  },
  {
    q: "Withdrawal me kitna time lagta hai?",
    a: "Average 3-5 minute me paise aapke account me. Kabhi-kabhi bank server slow hone par 15 min tak lag sakta hai.",
  },
  {
    q: "Minimum deposit kitna hai?",
    a: "Sirf ₹100 se shuru kar sakte ho. UPI, IMPS, USDT - sab options available hain.",
  },
  {
    q: "Kya mobile par chalega?",
    a: "Haan, hamari sabhi exchanges fully mobile optimized hain. Koi app download karne ki zarurat nahi - direct browser me chalao.",
  },
  {
    q: "Agar ID me koi problem aaye to?",
    a: "24x7 WhatsApp aur Telegram support available hai. Average 60 second me reply, aur 5 min me resolution.",
  },
  {
    q: "Konse games available hain?",
    a: "Cricket, Football, Tennis, Kabaddi sports ke saath Teen Patti, Andar Bahar, Lightning Roulette, Crazy Time, Aviator aur 650+ live casino games.",
  },
  {
    q: "Kya welcome bonus milta hai?",
    a: "Haan, naye users ko 5% welcome bonus pehle deposit par milta hai aur 10% loss commission har week.",
  },
];

export const STATS = [
  { value: "50K+", label: "Happy Users" },
  { value: "650+", label: "Live Games" },
  { value: "10", label: "Saal Trusted" },
  { value: "24/7", label: "Support" },
];

export const SERVICES = [
  { icon: "Trophy", title: "Online Cricket ID", desc: "IPL, World Cup, T20, Test, BBL, PSL - sabhi international aur domestic matches par live betting." },
  { icon: "Activity", title: "Live Sports Exchange", desc: "Back & Lay option ke saath cricket, football, tennis, kabaddi sab par real-time odds." },
  { icon: "Spade", title: "Live Casino ID", desc: "Teen Patti, Andar Bahar, Roulette, Blackjack, Baccarat - live dealers ke saath 250+ games." },
  { icon: "Plane", title: "Aviator & Crash Games", desc: "Fast earning ke liye Aviator, JetX, Crash games available 24x7." },
  { icon: "Users", title: "Refer & Earn", desc: "Doston ko refer karke commission kamao. Lifetime earnings aur instant payout." },
  { icon: "BarChart3", title: "Fantasy Sports", desc: "Daily fantasy contests with low entry fees aur big prize pools." },
];

export const TESTIMONIALS = [
  { name: "Rahul S.", city: "Mumbai", rating: 5, text: "2 saal se OnlineCricketID use kar raha hu. Withdrawal hamesha 5 min me. Best ID provider hai." },
  { name: "Amit K.", city: "Delhi", rating: 5, text: "IPL season me daily play karta hu. Live odds aur streaming dono best. Support team superb hai." },
  { name: "Vikas P.", city: "Pune", rating: 5, text: "Casino games ke liye OnlineCricketID best hai. Teen Patti aur Aviator par roz earning hoti hai." },
  { name: "Sanjay M.", city: "Lucknow", rating: 5, text: "Pehle bhi 3-4 ID providers try kiye lekin OnlineCricketID jaisi transparency kahi nahi mili." },
];

export const BLOG_POSTS = [
  {
    slug: "anna11-cricket-id-2026-guide",
    title: "OnlineCricketID.guru Cricket ID 2026: Instant, Safe & 24x7 ID Kaise Lein",
    date: "15 June 2026",
    author: "Anna",
    cover: "https://images.unsplash.com/photo-1512719994953-eabf50895df7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwc3RhZGl1bXxlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
    excerpt: "2026 me Online Cricket ID lene ka sabse asaan aur safe tarika. OnlineCricketID ke through 2 minute me apni ID activate karwao aur khelo top exchanges par.",
  },
  {
    slug: "how-to-get-cricket-id-online-5-minutes",
    title: "How to Get Cricket ID Online in 5 Minutes - Step by Step",
    date: "02 June 2026",
    author: "Anna",
    cover: "https://images.pexels.com/photos/36741131/pexels-photo-36741131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt: "Cricket ID kaise banaye sirf 5 minute me? Complete step-by-step guide WhatsApp se ID lene ka, deposit karne ka, aur safe play karne ka.",
  },
  {
    slug: "how-to-deposit-cricket-id-upi-100",
    title: "How to Deposit in Cricket ID via UPI from Just ₹100",
    date: "22 May 2026",
    author: "Anna",
    cover: "https://images.unsplash.com/photo-1606559497615-e4787c3c75a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjYXNpbm8lMjBjaGlwc3xlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
    excerpt: "Sirf ₹100 se deposit start kar sakte ho. UPI, PhonePe, Google Pay - sab options available. Detailed deposit guide with screenshots inside.",
  },
  {
    slug: "what-is-cricket-id-beginners-guide",
    title: "What is Cricket ID? 2026 Complete Beginner's Guide by Anna",
    date: "08 May 2026",
    author: "Anna",
    cover: "https://images.unsplash.com/photo-1593341646782-e0b495cff86d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwYmF0dGluZ3xlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
    excerpt: "Cricket ID kya hai? Online sports exchange par ID kaise kaam karti hai? Beginners ke liye 2026 ka complete guide.",
  },
  {
    slug: "toss-powerplay-session-markets-cricket",
    title: "How to Wager on Toss, Powerplay, and Session Markets in Cricket",
    date: "28 April 2026",
    author: "Anna",
    cover: "https://images.pexels.com/photos/17628651/pexels-photo-17628651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt: "Cricket ki different betting markets - Toss, Powerplay, Session, Fall of Wicket. Har ek ki strategy aur tips Anna ke 10 saal ke experience se.",
  },
  {
    slug: "cricket-betting-id-guide-2026",
    title: "Cricket Betting ID Guide 2026: Complete OnlineCricketID Walkthrough",
    date: "12 April 2026",
    author: "Anna",
    cover: "https://images.pexels.com/photos/15862398/pexels-photo-15862398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt: "Cricket betting ID ke saare features, advantages, aur safe play karne ke rules. OnlineCricketID par registration se withdrawal tak ka full walkthrough.",
  },
];

export const GAMES = [
  { name: "Teen Patti", tag: "Live · 3 Cards", img: "/games/teen-patti.jpg" },
  { name: "Andar Bahar", tag: "Live · Instant", img: "/games/andar-bahar.jpg" },
  { name: "Lightning Roulette", tag: "Evolution", img: "/games/roulette.jpg" },
  { name: "Aviator", tag: "Crash · Fast Win", img: "/games/aviator.jpg" },
  { name: "Dragon Tiger", tag: "Live Casino", img: "/games/dragon-tiger.jpg" },
  { name: "Live Cricket", tag: "IPL 2026 · Odds", img: "/games/live-cricket.jpg" },
];

export const IMAGES = {
  heroStadium: "https://images.unsplash.com/photo-1512719994953-eabf50895df7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwc3RhZGl1bXxlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
  modiStadium: "https://images.pexels.com/photos/36741131/pexels-photo-36741131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fans: "https://images.pexels.com/photos/15862398/pexels-photo-15862398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  casino: "https://images.unsplash.com/photo-1606559497615-e4787c3c75a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjYXNpbm8lMjBjaGlwc3xlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
  chips: "https://images.pexels.com/photos/1553831/pexels-photo-1553831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pokerChips: "https://images.unsplash.com/photo-1518133120397-258d5eb470c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxjYXNpbm8lMjBjaGlwc3xlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
  batting: "https://images.unsplash.com/photo-1593341646782-e0b495cff86d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwYmF0dGluZ3xlbnwwfHx8fDE3ODI1NjU1NTR8MA&ixlib=rb-4.1.0&q=85",
  battingAction: "https://images.pexels.com/photos/17628651/pexels-photo-17628651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
